import UserController from '../base'
import type { TResponseBase } from '~/services/MSAPI/types'
import type { NSurvey } from './types'

export default class UserControllerSurvey extends UserController {
  static readonly controllerPath = 'survey'
  private readonly serviceUrl: string

  constructor() {
    super(UserControllerSurvey.controllerPath)
    this.serviceUrl = this.getFullServiceUrl()
  }

  async getUserSurvey(context: string): TResponseBase<boolean> {
    return await useFetchInstance(`${this.serviceUrl}`, {
      method: 'GET',
      query: {
        context,
      },
    })
  }

  async createFeedback(body: NSurvey.IBody): TResponseBase<boolean> {
    return await useFetchInstance(`${this.serviceUrl}`, {
      method: 'POST',
      body,
    })
  }

  async getSurveyList(
    body: NSurvey.IListRequestBody,
    sortField: string,
    sort: number,
  ): TResponseBase<NSurvey.ISurvey[]> {
    return await useFetchInstance(`${this.serviceUrl}/list`, {
      method: 'GET',
      query: {
        ...body,
        sortField,
        sort,
      },
    })
  }

  async getSurveyReport(
    body: NSurvey.IListRequestBody,
  ): TResponseBase<NSurvey.ISurveyReportResult[]> {
    return await useFetchInstance(`${this.serviceUrl}/report`, {
      method: 'GET',
      query: {
        ...body,
      },
    })
  }

  async getContextList(): TResponseBase<string[]> {
    return await useFetchInstance(`${this.serviceUrl}/contextlist`, {
      method: 'GET',
    })
  }
}
